import React from 'react';
import { useLanguage } from './LanguageContext';

const LanguageSwitcher = () => {
  const { toggleLanguage, translations, getLanguageFlag } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 h-11 px-4 rounded-full border border-dark-border bg-dark-surface/80 backdrop-blur text-dark-muted transition-all duration-300 ease-out-soft hover:text-accent hover:border-accent/40 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-dark-bg"
      aria-label={translations.langSwitcher.switchTo}
    >
      <span className="text-base leading-none">{getLanguageFlag()}</span>
      <span className="font-medium text-sm">{translations.langSwitcher.switchTo}</span>
    </button>
  );
};

export default LanguageSwitcher;
